import { ShieldCheck, Clock, XCircle } from "lucide-react";

const BANNERS = {
  PENDING: { icon: Clock, cls: "bg-amber-50 text-amber-800", t: "Documents submitted — our team is verifying them. You can book now; verification must be approved before pickup." },
  APPROVED: { icon: ShieldCheck, cls: "bg-emerald-50 text-emerald-800", t: "You're verified. Just bring your original licence at pickup." },
  REJECTED: { icon: XCircle, cls: "bg-rose-50 text-rose-800", t: "Verification was rejected" },
};

export function KycBanner({ kyc }) {
  const banner = BANNERS[kyc.status];
  return (
    <>
      {banner && (
        <div className={`flex items-start gap-2 rounded-2xl p-4 text-sm ${banner.cls}`} data-testid="kyc-status-banner">
          <banner.icon className="mt-0.5 h-4 w-4 shrink-0" />
          <span>{banner.t}{kyc.status === "REJECTED" && `: ${kyc.reject_reason}. Please re-upload and submit again.`}</span>
        </div>
      )}
      {kyc.status === "NOT_SUBMITTED" && kyc.reject_reason && (
        <div className="flex items-start gap-2 rounded-2xl bg-rose-50 p-4 text-sm text-rose-800" data-testid="kyc-previous-reason">
          <XCircle className="mt-0.5 h-4 w-4 shrink-0" /><span>Previous submission was rejected: {kyc.reject_reason}. Fix this and submit again.</span>
        </div>
      )}
    </>
  );
}

const input = "mt-1 w-full rounded-xl border border-black/10 bg-white px-4 py-3 text-sm outline-none focus:ring-2 focus:ring-[#FF5A00]";

export function KycDetailsForm({ dl, setDl, a4, setA4, allDocs, busy, onSubmit }) {
  return (
    <>
      <div className="grid gap-3 sm:grid-cols-2">
        <label className="text-sm font-medium">Driving licence number
          <input data-testid="kyc-dl-number" value={dl} onChange={(e) => setDl(e.target.value.toUpperCase())} placeholder="e.g. KA0120201234567" className={input} />
        </label>
        <label className="text-sm font-medium">Aadhaar — last 4 digits
          <input data-testid="kyc-aadhaar-last4" value={a4} maxLength={4} inputMode="numeric" onChange={(e) => setA4(e.target.value.replace(/\D/g, ""))} placeholder="XXXX" className={input} />
        </label>
      </div>
      <button type="button" onClick={onSubmit} disabled={busy || !allDocs || !dl || a4.length !== 4} data-testid="kyc-submit-btn"
        className="w-full rounded-full bg-neutral-950 py-3.5 font-semibold text-white transition-colors duration-200 hover:bg-[#FF5A00] disabled:cursor-not-allowed disabled:bg-neutral-300">
        {busy ? "Submitting…" : allDocs ? "Submit for verification" : "Upload all documents and selfie to continue"}
      </button>
    </>
  );
}
